import { Check } from "lucide-react";

const reasons = [
  "Data-driven ad strategy",
  "High ROI campaign optimization",
  "Transparent reporting",
  "Continuous testing & scaling",
  "Performance-focused team",
];

export default function WhyUs() {
  return (
    <section
      data-testid="why-us-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="absolute -inset-4 bg-[#FF5722]/10 blur-3xl rounded-3xl pointer-events-none" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Team collaboration"
                className="w-full h-[480px] object-cover"
                data-testid="why-us-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="glass rounded-2xl p-5 flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-[#FF5722] flex items-center justify-center text-black font-bold text-xl">
                    R
                  </div>
                  <div>
                    <div className="text-white font-semibold">Predictable Growth</div>
                    <div className="text-xs text-zinc-400 mt-0.5">Systems, not guesses</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div>
            <div className="text-xs font-mono tracking-widest text-[#FF5722] uppercase mb-4">
              // Why Choose Us
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white leading-tight">
              Why Businesses <br />
              Choose <span className="gradient-text">RH Technology</span>
            </h2>
            <p className="mt-5 text-lg text-zinc-400 max-w-xl">
              We don&apos;t just run ads — we build systems that drive predictable,
              scalable revenue.
            </p>

            <ul className="mt-10 space-y-3" data-testid="why-us-list">
              {reasons.map((r, i) => (
                <li
                  key={i}
                  data-testid={`reason-${i}`}
                  className="flex items-center gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5 hover:border-[#FF5722]/30 hover:bg-white/[0.04] transition-all group"
                >
                  <div className="w-9 h-9 rounded-lg bg-[#FF5722]/10 border border-[#FF5722]/20 flex items-center justify-center group-hover:bg-[#FF5722] transition-colors">
                    <Check className="w-4 h-4 text-[#FF5722] group-hover:text-black transition-colors" strokeWidth={3} />
                  </div>
                  <span className="text-white font-medium">{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
